import { withInstall } from '@park-ui/utils'

import Affix from './src/affix.vue'

export const ElAffix = withInstall(Affix)
export default ElAffix

export * from './src/affix'
